import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { AccessDenied } from 'shared/errors/access-denied'
import { UnauthorizedResponse } from 'shared/errors/unauthorized-response'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { CommunityInterface } from '../types/community-interface'

interface UseJoinCommunityOptions {
  unauthorizedResponseHandler?: (error: UnauthorizedResponse) => void
  accessDeniedResponseHandler?: (error: AccessDenied) => void
}

export const useJoinCommunity = ({
  unauthorizedResponseHandler = error => {
    throw error
  },
  accessDeniedResponseHandler = error => {
    throw error
  },
}: UseJoinCommunityOptions = {}): UseMutationResult<CommunityInterface, Error, string> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, CommunityInterface>({
    method: RequestMethodsEnum.get,
    unauthorizedResponseHandler,
    accessDeniedResponseHandler,
  })

  return useMutation({
    mutationFn: async (communityPath: CommunityInterface['path']) => {
      if (communityPath.length === 0) {
        throw new Error('communityPath is required to join a community')
      }

      return await fetcher(`${COMMUNITY_API_PREFIX}/${communityPath}/join`)
    },
    retry: false,
  })
}
